import * as R from 'ramda'

export default R.pipe(R.toString, R.append('px'), R.join(''))
